import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/entrancePlants/helpSetup/help-set-up-the-plant.webp'

const _withId = /*#__PURE__*/_withScopeId("data-v-01ce9cfc")

_pushScopeId("data-v-01ce9cfc")
const _hoisted_1 = { class: "bt-icon bt-icon--xs" }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = { class: "p-4 lower-half" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", {
  class: "separator",
  style: {"background-color":"currentColor","opacity":"0.25"}
}, null, -1)
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "pl-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")

  return (_openBlock(), _createBlock(_component_ElDropdown, {
    onVisibleChange: _ctx.handleDropdownVisibleChange,
    trigger: "click",
    placement: "right-end",
    "popper-class": "el-dropdown__popper el-dropdown--context"
  }, {
    dropdown: _withId(() => [
      _createVNode(_component_ElDropdownMenu, null, {
        default: _withId(() => [
          _createVNode(_component_ElDropdownItem, null, {
            default: _withId(() => [
              (_ctx.helpType == _ctx.HelpTypeEnum.CallModeTypes)
                ? (_openBlock(), _createBlock("img", _hoisted_3))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_4, [
                _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.description), 1),
                (_ctx.helpType == _ctx.HelpTypeEnum.CallModeTypes)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.callModeHelpDescription, (text, index) => {
                      return (_openBlock(), _createBlock("span", { key: index }, [
                        _createTextVNode(_toDisplayString(text) + " ", 1),
                        _hoisted_6
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (_ctx.helpType == _ctx.HelpTypeEnum.RiserInterface)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("div", {
                        class: "mb-3",
                        innerHTML: _ctx.riserInterfaceHelpDescription[0]
                      }, null, 8, ["innerHTML"]),
                      _createVNode("div", {
                        class: "mb-1",
                        innerHTML: _ctx.riserInterfaceHelpDescription[1]
                      }, null, 8, ["innerHTML"]),
                      _createVNode("div", {
                        class: "mb-1",
                        innerHTML: _ctx.riserInterfaceHelpDescription[2]
                      }, null, 8, ["innerHTML"]),
                      _createVNode("div", {
                        class: "mb-0",
                        innerHTML: _ctx.riserInterfaceHelpDescription[3]
                      }, null, 8, ["innerHTML"]),
                      _hoisted_7,
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.riserInterfaceHelpPoints[0]), 1),
                      _createVNode("div", _hoisted_9, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riserInterfaceHelpPoints.slice(
                                        1
                                    ), (point, index) => {
                          return (_openBlock(), _createBlock("span", {
                            class: "d-block",
                            key: index
                          }, _toDisplayString(point), 1))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_Button, {
        class: ["p-button-rounded ml-auto", _ctx.showHelpDialog ? 'p-button-primary' : 'p-button-outlined'],
        onClick: _ctx.toggleHelpDialog
      }, {
        default: _withId(() => [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InlineSvgScoped, {
              src: 
                        require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                    ,
              "aria-label": "icon-alert"
            }, null, 8, ["src"])
          ]),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _: 1
  }, 8, ["onVisibleChange"]))
})